import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
interface ParallaxSectionProps {
  bgImage: string;
  overlayOpacity?: number;
  children: React.ReactNode;
  className?: string;
}
export function ParallaxSection({
  bgImage,
  overlayOpacity = 0.6,
  children,
  className = ''
}: ParallaxSectionProps) {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  // Move background slightly slower than scroll for parallax effect
  const y = useTransform(scrollYProgress, [0, 1], ['-20%', '20%']);
  return <section ref={ref} className={`relative overflow-hidden w-full flex items-center justify-center ${className}`} data-id="element-124">
      <motion.div style={{
      y,
      backgroundImage: `url(${bgImage})`
    }} className="absolute inset-[-20%] z-0 bg-cover bg-center" data-id="element-125" />
      <div className="absolute inset-0 z-10 bg-brand-black" style={{
      opacity: overlayOpacity
    }} data-id="element-126" />
      <div className="relative z-20 w-full" data-id="element-127">{children}</div>
    </section>;
}